if (!customElements.get('mm-hoodie-form')) {
  customElements.define('mm-hoodie-form', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('button');
      this.buttonText = this.button.textContent;
      this.status = this.querySelector('.mm-hoodie-status');
      this.inputs = [...this.querySelectorAll('[data-size]')];
      this.form.addEventListener('input', () => this.update());
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', event => this.submit(event));
      window.addEventListener('pageshow', () => { this.busy = false; this.button.textContent = this.buttonText; this.update(); });
      fetch(this.dataset.configUrl).then(r => { if (!r.ok) throw Error(); return r.json(); }).then(data => {
        this.config = data[this.dataset.productId];
        if (!this.config) throw Error();
        this.update();
      }).catch(() => { this.status.textContent = this.dataset.error; });
    }
    read() {
      const values = this.inputs.map(input => input.value === '' ? NaN : Number(input.value));
      const valid = values.every(n => Number.isInteger(n) && n >= 0 && n <= Number(this.dataset.count));
      const total = valid ? values.reduce((a,b) => a+b,0) : 0;
      const key = [this.form.elements.print.value, values[5], values[6]+values[7]+values[8]].join('|');
      return {values, total, valid:valid && total === Number(this.dataset.count), variant:this.config?.variants[key]};
    }
    money(cents) { return new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents/100); }
    update() {
      const state = this.read();
      this.querySelector('.mm-hoodie-count').textContent = `${state.total} / ${this.dataset.count} ${this.dataset.countText}`;
      this.querySelector('.mm-hoodie-total').textContent = state.variant ? `${this.dataset.totalText}: ${this.money(state.variant[1])} USD` : '';
      this.status.textContent = !this.config ? this.dataset.loading : state.valid && state.variant ? this.dataset.ready : `${this.dataset.invalid} ${this.dataset.count}.`;
      this.button.disabled = this.busy || !state.valid || !state.variant;
      return state;
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy) return;
      const state = this.update();
      if (!state.valid || !state.variant || !this.form.reportValidity()) return;
      this.busy = true; this.button.disabled = true; this.button.textContent = this.dataset.busy;
      try {
        const check = await fetch(`${this.dataset.root}variants/${state.variant[0]}.js`);
        if (!check.ok) throw Error();
        const live = await check.json();
        if (!live.available) throw Error();
        if (live.price !== state.variant[1]) {
          state.variant[1] = live.price; this.busy = false; this.update(); this.status.textContent = this.dataset.changed; return;
        }
        const properties = {'Package quantity':this.dataset.count,'Hoodie color':this.form.elements.color.value.trim(),'Print locations':this.form.elements.print.value,'Artwork':'Email artwork after checkout'};
        this.inputs.forEach((input,i) => {properties[input.dataset.size] = String(state.values[i]);});
        const response = await fetch(`${this.dataset.root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:state.variant[0],quantity:1,properties}]})});
        if (!response.ok) throw Error();
        window.location.assign(`${this.dataset.root}cart`);
      } catch (_) { this.status.textContent = this.dataset.error; this.busy = false; this.button.disabled = false; }
      finally { this.button.textContent = this.buttonText; }
    }
  });
}
